var common = require("../../utiles/common.js")
var service = require("../../utiles/service");
var layUtils = require("../../utiles/layUtils");

module.exports = {
    register: function () {
        document.createElement('entitlement')
        ko.components.register('entitlement', {
            viewModel: function (params) {
                var $this = this;
                var entitlementForm;
                $this.entitlement = ko.observable(false);
                common.fetch("/auth/entitlement/searchEntitlementForApply",{
                    type: "POST",
                    data: JSON.stringify({}),
                    success: function (result) {
                        $this.formData = {
                            fields: [
                                {
                                    display: commonLocal.app.PermissionSelection,
                                    type: "select",
                                    options: result.data,
                                    code: "id",
                                    name: "displayName",
                                    fieldName:"entitlementDefineId",
                                    rules:["required"],
                                },
                                {
                                    display: commonLocal.app.reason,
                                    type: "textarea",
                                    fieldName:"reason",
                                }
                            ],
                            selectBack:function(fields){
                                return fields.push({
                                    display: commonLocal.app.reason,
                                    type: "textarea",
                                    fieldName:"reason1",
                                });
                            },
                        }
                    }
                });

                $this.add = function(){
                    entitlementForm = layUtils.open({
                        type: 1,
                        area:["600px","500px"],
                        content: $("#entitlementId"),
                        form:{
                            formId:"entitlementId",
                            data:{},
                            callback:function(data){
                                console.log(data)
                                common.fetch("/auth/entitlement/requestEntitlement", {
                                    type: "GET",
                                    query: data,
                                    success: function (result) {
                                        console.log(result)
                                        layUtils.close(entitlementForm);
                                        $this.renderList();
                                    }
                                })
                            }
                        }
                    })
                }

                $this.remove = function (index) {
                    console.log(index)
                }

                $this.renderList = function () {
                    layUtils.table({
                        elem: '#entitlementList',
                        height: 600,
                        page: true,
                        url: '/auth/entitlement/searchEntitlementRequest',
                        cols: [[
                            {field: 'entitlementDefine', title: commonLocal.Authorization.AuthorityDefinition,templet:function(res){
                                return res.entitlementDefine?res.entitlementDefine.displayName:""
                            }},
                            {
                                field: 'status', title: commonLocal.Authorization.state, templet: function (res) {
                                    console.log(res)
                                    switch (res.status) {
                                        case "FINISHED":
                                            return "已完成";
                                        case "PROCESSING":
                                            return "进行中";
                                        case "CANCELED":
                                            return "已取消";
                                        case "ERROR":
                                            return "错误";
                                        default:
                                            return "";
                                    }
                                }
                            },
                            {field: 'errorMessage', title: commonLocal.Authorization.errorMessage,},
                            {field: 'action', title: commonLocal.Authorization.operation,width:100,templet:function(res){
                                if(res.status === "PROCESSING"){
                                    return '<a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="del"{{commonLocal.Authorization.cancel}}</a>'
                                }
                                return "";
                            }}
                        ]],
                        event: {
                            id: 'tool(entitlement)',
                            callback: function (item) {
                                console.log(item)
                                var trData = item.data;
                                var event = item.event;
                                if(event === "del"){
                                    layUtils.confirm("是否确定取消当前申请?",
                                    function(index, layero){
                                        console.log(index)
                                        common.fetch("/auth/entitlement/cancelEntitlementRequest",{
                                            type:"GET",
                                            query:{entitlementDefineId:trData.id},
                                            success:function(result){
                                                console.log(result)
                                                $this.renderList();
                                            }
                                        })
                                    })

                                }
                            }
                        }
                    });
                }

                $this.renderList();

            },
            template: require("./EntitlementDetail.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/entitlement/Entitlement.js
// module id = 166
// module chunks = 0